module.exports = __webpack_public_path__ + "media/on_a_star.83f50bae.wav";